export const FILES_ACCEPT_AVATAR = ['.png', 'jpg'];
